import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOrderDraft } from "../../context/OrderDraftContext";
import { useApi } from "../../hooks/useApi";
import { useCompanySelectionPrompt } from "../../hooks/useCompanySelectionPrompt";
import { chatService } from "../../services/chat";
import { saveService } from "../../services/save";
import { ApiOpmeRow } from "../../types/order.types";
import { SavePayload, SaveResponse } from "../../types/save.types";
import { PATHS } from "../../app/paths";

// Confirmar OPME (pacote ou escolha livre): pergunta as empresas, gera a
// justificativa técnica pela IA quando precisa, salva e segue para a indicação.
export const useOpmeSave = () => {
  const {
    timestamp, selectedButtonCheckKits, checkedItems, checkedKit,
    resumoOPME, setResumoOPME, observacoes, setSelectedCompanies,
  } = useOrderDraft();
  const companySelection = useCompanySelectionPrompt();
  const summaryApi = useApi<{ response: string }>();
  const saveApi = useApi<SaveResponse>();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const save = async (rows: ApiOpmeRow[], opmeProps: NonNullable<SavePayload["opmeProps"]>, newSummary: boolean) => {
    setSelectedCompanies(await companySelection.promptForCompanies());
    setSaving(true);
    try {
      let resumo = resumoOPME;
      if (newSummary) {
        const procedures = selectedButtonCheckKits === "escolha-livre" ? checkedItems : checkedKit;
        const res = await summaryApi.request(() =>
          chatService.resumoOpme(summaryApi.apiFetch, { procedures: procedures.map((p) => p.description), resumoOPME, opme_data: rows })
        );
        // Se a IA falhar, salva com o resumo anterior (o erro já apareceu no toast).
        if (res?.response) {
          resumo = res.response;
          setResumoOPME(resumo);
        }
      }
      const payload: SavePayload = { timestamp, opme_list: rows, observacoesOpme: observacoes, resumoOPME: resumo, opmeProps };
      const result = await saveApi.request(() => saveService.post(saveApi.apiFetch, payload));
      if (result?.status === "success") navigate(PATHS.surgicalIndication);
    } finally {
      setSaving(false);
    }
  };

  return { save, saving, companySelection };
};

export type OpmeSave = ReturnType<typeof useOpmeSave>["save"];
